import { fetcher } from "@/lib/apiFetch";
import { Font } from "@/pages/api/google-fonts";
import useSWR from "swr";

export function useGoogleFonts() {
  const { data, error } = useSWR(["/api/google-fonts"], fetcher<any>, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    suspense: false,
    shouldRetryOnError: false,
  });
  return {
    fonts: (data?.data ?? []) as Font[],
    isLoading: !error && !data,
    isError: error,
  };
}
